export const themes = [
  'Love and Affection',
  'Excitement and Intensity',
  'Surprise and Revelation',
  'Loss and Heartache',
  'Humor and Playfulness',
  'Conflict and Suspicion',
  'Triumph and Success',
  'Pursuit and Escape',
  'Magic and Wonder',
  'Memory and Reflection',
]
